import { Route } from 'vue-router'
import store from '../store'

export default async (to: Route, from: Route, next: any): Promise<void> => {
  if (store.getters.currentUser) {
    next()
  } else {
    next('/signin')
  }
}
